/**
 * Newsletter Module
 */
export class Newsletter {
    constructor(form) {
        this.form = form;
        this.init();
    }
    init() {
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }
    async handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(this.form);
        const email = formData.get('email');
        if (!email)
            return;
        try {
            this.form.classList.add('is-loading');
            const response = await fetch('/api/newsletter/subscribe', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });
            const data = await response.json();
            if (data.success) {
                this.showMessage('Thank you for subscribing!', 'success');
                this.form.reset();
            }
            else {
                this.showMessage(data.error || 'Failed to subscribe', 'error');
            }
        }
        catch (error) {
            this.showMessage('Failed to subscribe', 'error');
        }
        finally {
            this.form.classList.remove('is-loading');
        }
    }
    showMessage(text, type) {
        let msgEl = this.form.querySelector('.newsletter-message');
        if (!msgEl) {
            msgEl = document.createElement('div');
            msgEl.className = 'newsletter-message';
            this.form.appendChild(msgEl);
        }
        msgEl.textContent = text;
        msgEl.className = `newsletter-message newsletter-message--${type}`;
    }
}
export default Newsletter;
